import React, { Component } from "react";
import { connect } from 'react-redux';
import moment from 'moment';
import { toast } from 'react-toastify';

/* for "axios" request cancelation */
import axios from 'axios';

/* Helpers */
import { history } from '../../../helpers/history';

/* Services */
import ParentService from "../../../services/parent.service";

/* Ant Design */
import { Typography, Card, List, Row, Col, Tag, Image } from 'antd';

/* for "axios" request cancelation check variable */
let source;

class PatientPrescription extends Component {
    constructor(props) {
        super(props);
        this.getPatientPrescription = this.getPatientPrescription.bind(this);

        history.listen((location) => {
            props.patientDispatch.clearPatient();
            props.doctorDispatch.clearDoctor();
            props.prescriptionDispatch.clearPrescriptions();
        });
    }

    componentDidMount() {
        /* Component Mount olurken source'a token iletilir */
        source = axios.CancelToken.source();

        this.props.patientDispatch.clearPatient();
        this.props.doctorDispatch.clearDoctor();
        this.props.prescriptionDispatch.clearPrescriptions();

        this.getPatientPrescription();
    }

    getPatientPrescription() {
        this.props.prescriptionDispatch.setLoading(true);

        ParentService.getPrescription(this.props.match.params.prescriptionId, source.token)
            .then(
                (res) => {
                    this.props.prescriptionDispatch.setPrescription(res.data);
                    this.props.prescriptionDispatch.setLoading(false);
                },
                error => {
                    const resMessage =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();


                    /* Request cancel edildiğinde message olarak 'Cancel' dönüyor. Hata bildirimi verilmesini engellemek için */
                    if (resMessage !== 'Cancel') {
                        toast.error(resMessage);
                    }
                    this.props.prescriptionDispatch.setLoading(false);
                }
            )
    }

    componentWillUnmount() {
        /* Component Unmount edilirken cancel triggerı tetiklenir */
        if (source) {
            source.cancel();
        }
    }

    render() {
        let gamesCount = 0;

        return (
            <div>
                <div>
                    <Card style={{ marginTop: 16 }} loading={this.props.prescription.loading}>
                        <Card.Meta
                            title={
                                <div>
                                    <Typography.Title level={3} style={{ textAlign: 'center' }}>
                                        <Typography.Text style={{ fontWeight: 'bold' }}>"{this.props.prescriptionDetail.HastaID.AdSoyad}"</Typography.Text> için Reçete
                                        <br />
                                        {this.props.prescriptionDetail.AktifMi ?
                                            <Tag color={'success'}>
                                                Aktif Reçete
                                            </Tag>
                                            :
                                            <Tag color={'error'}>
                                                Pasif Reçete
                                            </Tag>
                                        }
                                    </Typography.Title>
                                </div>
                            }
                        />
                        <br />
                        <Typography.Title level={5}>
                            Doktor Bilgileri
                        </Typography.Title>
                        {this.props.prescriptionDetail.DoktorID.AdSoyad &&
                            <List size="larger" bordered>
                                {/* İsim - Adres */}
                                <List.Item>
                                    <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                        <Col span={12}>
                                            <Typography.Text style={{ fontWeight: 'bold' }}>İsim: </Typography.Text>
                                            <Typography.Text>{this.props.prescriptionDetail.DoktorID.AdSoyad}</Typography.Text>
                                        </Col>
                                        <Col span={12}>
                                            <Typography.Text style={{ fontWeight: 'bold' }}>Adres: </Typography.Text>
                                            <Typography.Text>{this.props.prescriptionDetail.DoktorID.Adres}</Typography.Text>
                                        </Col>
                                    </Row>
                                </List.Item>
                                {/* Cinsiyet - Eposta */}
                                <List.Item>
                                    <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                        <Col span={12}>
                                            <Typography.Text style={{ fontWeight: 'bold' }}>Cinsiyet: </Typography.Text>
                                            <Typography.Text>{this.props.prescriptionDetail.DoktorID.Cinsiyet}</Typography.Text>
                                        </Col>
                                        <Col span={12}>
                                            <Typography.Text style={{ fontWeight: 'bold' }}>E-Posta: </Typography.Text>
                                            <Typography.Text>{this.props.prescriptionDetail.DoktorID.Eposta}</Typography.Text>
                                        </Col>
                                    </Row>
                                </List.Item>
                            </List>
                        }
                        <br />
                        <Typography.Title level={5}>
                            Hasta Bilgileri
                        </Typography.Title>
                        {this.props.prescriptionDetail.HastaID.AdSoyad &&
                            <List size="larger" bordered>
                                {/* İsim - Doğum Tarihi */}
                                <List.Item>
                                    <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                        <Col span={12}>
                                            <Typography.Text style={{ fontWeight: 'bold' }}>İsim: </Typography.Text>
                                            <Typography.Text>{this.props.prescriptionDetail.HastaID.AdSoyad}</Typography.Text>
                                        </Col>
                                        <Col span={12}>
                                            <Typography.Text style={{ fontWeight: 'bold' }}>Doğum Tarihi: </Typography.Text>
                                            <Typography.Text>{moment(new Date(this.props.prescriptionDetail.HastaID.DogumTarihi)).format('LL')}</Typography.Text>
                                        </Col>
                                    </Row>
                                </List.Item>
                                {/* Cinsiyet - Yaş */}
                                <List.Item>
                                    <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                        <Col span={12}>
                                            <Typography.Text style={{ fontWeight: 'bold' }}>Cinsiyet: </Typography.Text>
                                            <Typography.Text>{this.props.prescriptionDetail.HastaID.Cinsiyet}</Typography.Text>
                                        </Col>
                                        <Col span={12}>
                                            <Typography.Text style={{ fontWeight: 'bold' }}>Yaş: </Typography.Text>
                                            <Typography.Text>{moment().diff(this.props.prescriptionDetail.HastaID.DogumTarihi, 'years', false)}</Typography.Text>
                                        </Col>
                                    </Row>
                                </List.Item>
                            </List>
                        }
                        <br />
                        <Typography.Title level={4}>
                            Reçete Bilgileri
                        </Typography.Title>
                        {this.props.prescriptionDetail &&
                            <List size="larger" bordered>
                                {/* Reçete Açıklama */}
                                <List.Item>
                                    <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                        <Col span={24}>
                                            <Typography.Text style={{ fontWeight: 'bold' }}>Açıklama: </Typography.Text>
                                            <Typography.Text>{this.props.prescriptionDetail.ReceteAciklama}</Typography.Text>
                                        </Col>
                                    </Row>
                                </List.Item>
                                {/* Reçete Durum & Reçete Tarihi & Pasif Tarihi */}
                                <List.Item>
                                    <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                        <Col span={8}>
                                            <Typography.Text style={{ fontWeight: 'bold' }}>Durum: </Typography.Text>
                                            <Typography.Text>
                                                {this.props.prescriptionDetail.AktifMi ?
                                                    <Tag color={'success'}>
                                                        Aktif Reçete
                                                    </Tag>
                                                    :
                                                    <Tag color={'error'}>
                                                        Pasif Reçete
                                                    </Tag>
                                                }
                                            </Typography.Text>
                                        </Col>
                                        {this.props.prescriptionDetail.ReceteTarihi &&
                                            <Col span={8}>
                                                <Typography.Text style={{ fontWeight: 'bold' }}>Reçete Tarihi: </Typography.Text>
                                                <Typography.Text>{moment(new Date(this.props.prescriptionDetail.ReceteTarihi)).format('LL')}</Typography.Text>
                                            </Col>
                                        }
                                        {this.props.prescriptionDetail.PasifTarihi &&
                                            <Col span={8}>
                                                <Typography.Text style={{ fontWeight: 'bold' }}>Pasif Tarihi: </Typography.Text>
                                                <Typography.Text>{moment(new Date(this.props.prescriptionDetail.PasifTarihi)).format('LL')}</Typography.Text>
                                            </Col>
                                        }
                                    </Row>
                                </List.Item>
                            </List>
                        }
                        <br />
                        <Typography.Title level={5}>
                            Oyun Bilgileri
                        </Typography.Title>
                        {this.props.prescriptionDetail.Oyunlar &&
                            (this.props.prescriptionDetail.Oyunlar.map(oyun => (
                                <div key={oyun._id}>
                                    <Row type="flex" gutter={[8, 8]} style={{ width: '100%', alignItems: 'center' }}>
                                        <Col xs={24} md={24} lg={8} xl={5}>
                                            <Image
                                                preview={false}
                                                width={'100%'}
                                                src={oyun.OyunID.PhotoLink}
                                                alt={oyun.OyunID.OyunAdi}
                                                fallback="data:image/png;base64,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"
                                            />
                                        </Col>
                                        <Col xs={24} md={24} lg={16} xl={19}>
                                            <List size="larger" style={((gamesCount + 1) % 2 === 0) ? { backgroundColor: '#FFFFFF' } : { backgroundColor: '#E8E8E8' }} bordered>
                                                {/* İsim - Hafta - Durum */}
                                                <List.Item>
                                                    <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                                        <Col span={12}>
                                                            <Typography.Text style={{ fontWeight: 'bold' }}>#{gamesCount += 1}&emsp;İsim: </Typography.Text>
                                                            <Typography.Text>{oyun.OyunID.OyunAdi}</Typography.Text>
                                                        </Col>
                                                        {oyun.Hafta &&
                                                            <Col span={8}>
                                                                <Typography.Text style={{ fontWeight: 'bold' }}>Hafta: </Typography.Text>
                                                                <Typography.Text>{oyun.Hafta} Hafta</Typography.Text>
                                                            </Col>
                                                        }
                                                        {oyun.OyunID &&
                                                            <Col span={4}>
                                                                <Typography.Text style={{ fontWeight: 'bold' }}>Durum: </Typography.Text>
                                                                {
                                                                    oyun.OyunID.Free === true ?
                                                                        <Tag color="green">Ücretsiz</Tag>
                                                                        :
                                                                        <Tag color="red">Ücretli</Tag>
                                                                }
                                                            </Col>
                                                        }
                                                    </Row>
                                                </List.Item>
                                                {/* Açıklama - Haftada Kaç Gün */}
                                                <List.Item>
                                                    <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                                        <Col span={12}>
                                                            <Typography.Text style={{ fontWeight: 'bold' }}>Açıklama: </Typography.Text>
                                                            <Typography.Text>{oyun.OyunID.OyunAciklama}</Typography.Text>
                                                        </Col>
                                                        {oyun.HaftadaKacGun &&
                                                            <Col span={8}>
                                                                <Typography.Text style={{ fontWeight: 'bold' }}>Haftada Kaç Gün: </Typography.Text>
                                                                <Typography.Text>{oyun.HaftadaKacGun} Gün</Typography.Text>
                                                            </Col>
                                                        }
                                                        <Col span={4}>
                                                            <Typography.Text style={{ fontWeight: 'bold' }}>Oyuna Sahip Misiniz?: </Typography.Text>
                                                            {
                                                                oyun.hasGame ?
                                                                    <Tag color="green">Evet</Tag>
                                                                    :
                                                                    <Tag color="red">Hayır</Tag>
                                                            }
                                                        </Col>
                                                    </Row>
                                                </List.Item>
                                                {/* Kategori - Günde Kaç Kez */}
                                                <List.Item>
                                                    <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                                        {oyun.OyunID.KategoriID &&
                                                            <Col span={12}>
                                                                <Typography.Text style={{ fontWeight: 'bold' }}>Kategori: </Typography.Text>
                                                                <Tag color="volcano">{oyun.OyunID.KategoriID.KategoriAdi}</Tag>
                                                            </Col>
                                                        }
                                                        {oyun.GundeKacKez &&
                                                            <Col span={12}>
                                                                <Typography.Text style={{ fontWeight: 'bold' }}>Günde Kaç Kez: </Typography.Text>
                                                                <Typography.Text>{oyun.GundeKacKez} Kere</Typography.Text>
                                                            </Col>
                                                        }
                                                    </Row>
                                                </List.Item>
                                                {/* Egzersiz Tipi - Oyun Süresi */}
                                                <List.Item>
                                                    <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                                        {oyun.OyunID.EgzersizTipiID &&
                                                            <Col span={12}>
                                                                <Typography.Text style={{ fontWeight: 'bold' }}>Egzersiz Tipi: </Typography.Text>
                                                                <Tag color="magenta">{oyun.OyunID.EgzersizTipiID.EgzersizTipiAdi}</Tag>
                                                            </Col>
                                                        }
                                                        {oyun.OyunSuresi &&
                                                            <Col span={12}>
                                                                <Typography.Text style={{ fontWeight: 'bold' }}>Oyun Süresi: </Typography.Text>
                                                                <Typography.Text>{oyun.OyunSuresi} Dakika</Typography.Text>
                                                            </Col>
                                                        }
                                                    </Row>
                                                </List.Item>
                                                {/* Reçete Oyun Açıklaması */}
                                                <List.Item>
                                                    <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                                        {oyun.OyunAciklama &&
                                                            <Col span={24}>
                                                                <Typography.Text style={{ fontWeight: 'bold' }}>Reçete Oyun Açıklaması: </Typography.Text>
                                                                <Typography.Text>{oyun.OyunAciklama}</Typography.Text>
                                                            </Col>
                                                        }
                                                    </Row>
                                                </List.Item>
                                            </List>
                                        </Col>
                                    </Row>
                                    <br />
                                </div>
                            )))
                        }
                    </Card>
                </div>
            </div >
        )
    }
}

const mapState = (state) => ({
    prescription: state.prescription,
    prescriptionDetail: state.prescription.patientPrescription,
    patient: state.patient,
    doctor: state.doctor,
});

const mapDispatch = (dispatch) => ({
    prescriptionDispatch: dispatch.prescription,
    patientDispatch: dispatch.patient,
    doctorDispatch: dispatch.doctor,
});

export default connect(mapState, mapDispatch)(PatientPrescription);